import React, { useState,useRef } from "react";
import axios from "axios";



const TARGET_SIZE = 90 * 1024; // 8KB target (safe)

const DocketWiseKycUpload: React.FC = () => {
  const [ticketNo, setTicketNo] = useState("");
  const [kyc1, setKyc1] = useState<File | null>(null);
  const [kyc2, setKyc2] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const kyc1Ref = useRef<HTMLInputElement>(null);
  const kyc2Ref = useRef<HTMLInputElement>(null);

  // Convert JPG/JPEG/PNG → PNG (~8KB)
  const convertToPng = (file: File): Promise<File> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = () => (img.src = reader.result as string);
      reader.onerror = reject;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d")!;
        let width = img.width;
        let height = img.height;

        const compress = () => {
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              if (!blob) return reject("Conversion failed");

              if (blob.size <= TARGET_SIZE || width < 120) {
                resolve(
                  new File(
                    [blob],
                    file.name.replace(/\.\w+$/, ".png"),
                    { type: "image/png" }
                  )
                );
              } else {
                width *= 0.75;
                height *= 0.75;
                compress();
              }
            },
            "image/png"
          );
        };

        compress();
      };

      reader.readAsDataURL(file);
    });
  };

  const handleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
    setFile: React.Dispatch<React.SetStateAction<File | null>>
  ) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // ✅ Allow ONLY JPG, JPEG, PNG
    const allowedTypes = ["image/jpeg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG, PNG images allowed");
      return;
    }

    try {
      const png = await convertToPng(file);
      setFile(png);
    } catch {
      alert("Image conversion failed");
    }
  };

  // const handleSubmit = async () => {
  //   if (!ticketNo.trim()) {
  //     alert("Ticket No required");
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("Ticket_No", ticketNo);
  //   if (kyc1) formData.append("KYC1", kyc1);
  //   if (kyc2) formData.append("KYC2", kyc2);

  //   try {
  //     setLoading(true);
  //     const res = await axios.post(
  //       "http://localhost:3200/Booking/DocketWiseKycUpload",
  //       formData
  //     );
  //     alert(res.data.Message);
  //   } catch {
  //     alert("Upload failed");
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const handleSubmit = async () => {
  if (!ticketNo.trim()) {
    alert("Ticket No required");
    return;
  }

  const formData = new FormData();
  formData.append("Ticket_No", ticketNo);
  if (kyc1) formData.append("KYC1", kyc1);
  if (kyc2) formData.append("KYC2", kyc2);

  try {
    setLoading(true);
    const res = await axios.post(
      "http://localhost:3200/Booking/DocketWiseKycUpload",
      formData
    );

    alert(res.data.Message);

    // ✅ CLEAR FORM AFTER SUCCESS
    setTicketNo("");
    setKyc1(null);
    setKyc2(null);

    if (kyc1Ref.current) kyc1Ref.current.value = "";
    if (kyc2Ref.current) kyc2Ref.current.value = "";

  } catch {
    alert("Upload failed");
  } finally {
    setLoading(false);
  }
};




  return (
    <div style={{ maxWidth: 400, margin: "40px auto" }}>
      <h3>KYC Upload (JPG / JPEG / PNG)</h3>

      <input
        type="text"
        placeholder="Ticket No"
        value={ticketNo}
        onChange={(e) => setTicketNo(e.target.value)}
      />

      <br /><br />

      <label>KYC Image 1</label>
      <input
        ref={kyc1Ref}
        type="file"
        accept=".jpg,.jpeg,.png"
        onChange={(e) => handleFileChange(e, setKyc1)}
      />

      <br /><br />

      <label>KYC Image 2</label>
      <input
        ref={kyc2Ref}
        type="file"
        accept=".jpg,.jpeg,.png"
        onChange={(e) => handleFileChange(e, setKyc2)}
      />

      <br /><br />

      <button onClick={handleSubmit} disabled={loading}>
        {loading ? "Uploading..." : "Upload"}
      </button>

    </div>
  );
};

export default DocketWiseKycUpload;
